export default {"src":"/_next/static/media/outlook-icon.2508492e.svg","height":19,"width":20,"blurWidth":0,"blurHeight":0};